import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ClaimFormStep from '../components/claimFormStep/claimFormStep';
import Attachments from '../components/attachments/attachments';
import codes from '../utils/constants/codes';

const StepsRouter = props => {
    const match = useRouteMatch();
    return (
        <Switch>
            <Route
                path={`${match.path}/${codes.attachments}`}
                render={() => <Attachments {...props} />}
            />
            <Route
                path={`${match.path}/:step`}
                render={() => <ClaimFormStep {...props} />}
            />
        </Switch>
    );
};

export default StepsRouter;
